const initFermentationRecipes = (section) => {
  if (!section || section.dataset.sealFermentationRecipesReady === 'true') return;
  section.dataset.sealFermentationRecipesReady = 'true';

  const track = section.querySelector('[data-fermentation-recipe-track]');
  const recipes = [...section.querySelectorAll('[data-fermentation-recipe]')];
  const previousButton = section.querySelector('[data-fermentation-recipe-previous]');
  const nextButton = section.querySelector('[data-fermentation-recipe-next]');
  const progressMarkers = [...section.querySelectorAll('[data-fermentation-recipe-progress]')];
  const status = section.querySelector('[data-fermentation-recipe-status]');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const reveals = [...section.querySelectorAll('[data-fermentation-recipe-reveal]')];
  if (reduceMotion || !('IntersectionObserver' in window)) {
    reveals.forEach((element) => element.classList.add('is-visible'));
  } else {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -7% 0px', threshold: 0.1 }
    );
    reveals.forEach((element) => observer.observe(element));
  }

  if (!track || recipes.length < 2 || !previousButton || !nextButton) return;

  let currentIndex = 0;
  let scrollFrame;

  const updateNavigation = (nextIndex) => {
    currentIndex = Math.max(0, Math.min(nextIndex, recipes.length - 1));
    previousButton.disabled = currentIndex === 0;
    nextButton.disabled = currentIndex === recipes.length - 1;
    progressMarkers.forEach((marker, index) => {
      marker.classList.toggle('is-active', index === currentIndex);
    });

    if (status) {
      status.textContent = (status.dataset.statusTemplate || '')
        .replace('__current__', String(currentIndex + 1))
        .replace('__total__', String(recipes.length));
    }
  };

  const getNearestRecipeIndex = () => {
    const trackLeft = track.getBoundingClientRect().left;
    return recipes.reduce((nearestIndex, recipe, index) => {
      const nearestDistance = Math.abs(recipes[nearestIndex].getBoundingClientRect().left - trackLeft);
      const distance = Math.abs(recipe.getBoundingClientRect().left - trackLeft);
      return distance < nearestDistance ? index : nearestIndex;
    }, 0);
  };

  const scrollToRecipe = (nextIndex) => {
    const targetIndex = Math.max(0, Math.min(nextIndex, recipes.length - 1));
    const trackRect = track.getBoundingClientRect();
    const recipeRect = recipes[targetIndex].getBoundingClientRect();
    const left = track.scrollLeft + recipeRect.left - trackRect.left;
    track.scrollTo({ left, behavior: reduceMotion ? 'auto' : 'smooth' });
    updateNavigation(targetIndex);
  };

  previousButton.addEventListener('click', () => scrollToRecipe(currentIndex - 1));
  nextButton.addEventListener('click', () => scrollToRecipe(currentIndex + 1));
  track.addEventListener(
    'scroll',
    () => {
      cancelAnimationFrame(scrollFrame);
      scrollFrame = requestAnimationFrame(() => updateNavigation(getNearestRecipeIndex()));
    },
    { passive: true }
  );

  updateNavigation(0);
};

const initAllFermentationRecipes = () => {
  document.querySelectorAll('[data-seal-fermentation-recipes]').forEach(initFermentationRecipes);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllFermentationRecipes);
} else {
  initAllFermentationRecipes();
}

document.addEventListener('shopify:section:load', (event) => {
  const section = event.target?.querySelector?.('[data-seal-fermentation-recipes]');
  if (!section) return;
  section.dataset.sealFermentationRecipesReady = 'false';
  initFermentationRecipes(section);
});
